<template>
    <div class="clipping_menu">
        <PaintConfig/>
        <div class="caption">
            消しゴムツールで家具にかかる製品部分を削除すると、その部分の製品が見えなくなります。<br>えんぴつツールで書き足せば、製品を家具の前に表示することができます。
        </div>
    </div>
</template>

<script>
    import PaintConfig from '../parts/PaintConfig'

    export default {
        name: "ClippingMenu",
        components: {PaintConfig}
    }
</script>

<style scoped lang="scss">
    .clipping_menu {
        width: calc(100% - 20px);
        padding: 10px;
        border: 1px solid #000;
        border-radius: 5px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .caption {
            background-color: #D1D1D1;
            box-sizing: border-box;
            padding: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: clamp(10px, 1vw, 13px);
            height: 80px;
        }
    }
    @media screen and (max-width:799px) {
        .clipping_menu {
            padding: 5px 10px;
            .caption {
                padding: 5px;
                height: 70px;
            }
        }
    }

</style>
